import React, { useState, useEffect } from "react";

function ProgressBar({ questionIndex }) {
  const [time, setTime] = useState(0);
  const [progress, setProgress] = useState(100);

  useEffect(() => {
    const resetProgressBarCleanup = resetProgressBar(setProgress);
    const resetTimeCleanup = resetTime(setTime);

    return () => {
      resetProgressBarCleanup();
      resetTimeCleanup();
    };
  }, [questionIndex]);

  return (
    <>
      <p className="text-center font-bold mb-4">Din tid</p>
      <div className="w-full flex items-center gap-2">
        <p className="leading-none m-0 font-semibold text-xs">{time}:00</p>
        <div className="w-full h-3 bg-white grow rounded-full overflow-hidden">
          <div
            className="h-full bg-primary rounded-full"
            style={{
              width: `${progress}%`,
              transition: "width cubic-bezier(0.4, 0, 0.2, 1)",
            }}
          ></div>
        </div>
        <p className="leading-none m-0 font-semibold text-xs">30:00</p>
      </div>
    </>
  );

  function resetProgressBar() {
    setProgress(100);
    const interval = setInterval(() => {
      setProgress((prevWidth) => (prevWidth > 0 ? prevWidth - 1 : 0));
    }, 30000 / 100);

    return () => clearInterval(interval);
  }

  function resetTime() {
    setTime(30);
    const interval = setInterval(() => {
      setTime((prevTime) => {
        if (prevTime > 0) {
          return prevTime - 1;
        } else {
          clearInterval(interval);
          return 0;
        }
      });
    }, 1000);

    return () => clearInterval(interval);
  }
}

export default ProgressBar;
